import React from "react";
import './taTable.css';

export class TaTableColumns extends React.PureComponent {

  render() {
    const {
      className,
      ...attributes
    } = this.props;

    const baseClass = 'ta-table-columns';
    let classNames = [baseClass];
    if (className) {
      classNames.push(className);
    }

    return (
      <div className={classNames.join(' ')} {...attributes}>{this.props.children}</div>
    )
  }

}
